module.exports = __webpack_public_path__ + "static/img/head-ar.8026922d.webp";